module.exports = __webpack_public_path__ + "static/img/SearchDetailEnterprise12.00130b6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailEnterprise12.png
// module id = 720
// module chunks = 0